import { render } from "./AtendimentoPacienteRelatorio.vue?vue&type=template&id=13ed3fa8&scoped=true"
import script from "./AtendimentoPacienteRelatorio.vue?vue&type=script&lang=js"
export * from "./AtendimentoPacienteRelatorio.vue?vue&type=script&lang=js"

import "./AtendimentoPacienteRelatorio.vue?vue&type=style&index=0&id=13ed3fa8&scoped=true&lang=css"

import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13ed3fa8"]])

export default __exports__